export const PlayCircle = () => (
  <svg version="1.2" xmlns="http://www.w3.org/2000/svg" overflow="visible" preserveAspectRatio="none" viewBox="0 0 16 17">
    <path fill="currentColor" d="M8 0C3.584 0 0 3.808 0 8.5S3.584 17 8 17s8-3.808 8-8.5S12.416 0 8 0zM6.4 12.325v-7.65L11.2 8.5z"/>
  </svg>
);
